import { request } from '@/api/client';
export type BandsintownStatus = {
  configured: boolean; status: string; revision: number; profile_url?: string;
  last_success_at?: string; last_attempt_at?: string; last_error_code?: string;
  live_enabled: boolean; recurring_enabled: boolean; can_manage?: boolean; can_sync?: boolean;
  summary?: Record<string, number>;
};
export function bandsintownRequest(artistId: string, action = '', method = 'GET', body?: unknown) {
  return request<BandsintownStatus>(`/artists/me/integrations/bandsintown${action}`, {
    method, headers: { 'X-Artist-Id': artistId }, ...(body === undefined ? {} : { body }), timeoutMs: 120000,
  });
}
